import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Contact = () => {

    const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
    comment: ""
  });

  const [responseMsg, setResponseMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("https://api.welbeing.in/contact/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phonenumber: formData.number,
          description: formData.comment
        })
      });

      const data = await res.json();
      if (data.status === "success") {
        setResponseMsg("Your message has been sent successfully!");
        setFormData({ name: "", email: "", number: "", comment: "" });
        setTimeout(() => setResponseMsg(""), 5000);
      } else {
        setResponseMsg("There was a problem submitting the form. Please try again.");
        setTimeout(() => setResponseMsg(""), 5000);
      }
    } catch (error) {
      setResponseMsg("Server error. Please try again later.");
      setTimeout(() => setResponseMsg(""), 5000);
    }
  };
    return (
        <>
        <Header/>
            <main className="main">
                <div className="breadcrumb-wrap" id="breadcrumb-margin">
          <div className="banner" style={{minHeight:'10px'}}>
                        <img className="bg-img bg-top" src="assets/images/inner-page/banner.jpg" alt="banner" />
                        <div className="container-lg">
                            <div className="breadcrumb-box">
                                <div className="heading-box">
                                    <h1>Contact Us</h1>
                                </div>
                                <ol className="breadcrumb">
                                    <li><a href="/">Home</a></li>
                                    <li>
                                        <a href="javascript:void(0)"><i data-feather="chevron-right"></i></a>
                                    </li>
                                    <li className="current"><a href="/contact">Contact Us</a></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="contact-section">
                    <div className="container-lg">
                        <div className="row gy-4 gy-xl-0 gx-0 gx-xl-4">
                            <div className="col-xl-8 order-2 order-xl-1">
                                <div className="replay-form round-wrap-content top-space" id="replaySection">
                                    <div className="title-box4">
                                        <h4 className="heading">Leave a Comment<span className="bg-theme-blue"></span></h4>
                                    </div>

                                    <form className="custom-form form-pill" onSubmit={handleSubmit}>
                                        {responseMsg && (
                                        <div className="col-12">
                                          <p className="alert alert-info">{responseMsg}</p>
                                        </div>
                                      )}
                                     <div className="row g-3 g-sm-4">
                                      <div className="col-sm-12">
                                        <div className="input-box">
                                          <label htmlFor="name">First Name</label>
                                          <input name="name" id="name" type="text" className="form-control" value={formData.name} onChange={handleChange} required/>
                                        </div>
                                      </div>

                                      <div className="col-sm-6">
                                        <div className="input-box">
                                          <label htmlFor="email">Email Address</label>
                                          <input name="email" id="email" type="email" className="form-control" value={formData.email} onChange={handleChange} required/>
                                        </div>
                                      </div>

                                      <div className="col-sm-6">
                                        <div className="input-box">
                                          <label htmlFor="number">Phone Number</label>
                                          <input name="number" id="number" type="tel" className="form-control" value={formData.number} onChange={handleChange} required/>
                                        </div>
                                      </div>

                                      <div className="col-12">
                                        <div className="input-box">
                                          <label htmlFor="comment">Comments</label>
                                          <textarea name="comment" id="comment" className="form-control" rows="5" value={formData.comment} onChange={handleChange} required ></textarea>
                                        </div>
                                      </div>

                                      <div className="col-12 text-end">
                                        <button className="post-button btn btn-solid btn-sm mb-line" type="submit">
                                          Post Comment <i className="arrow"></i>
                                        </button>
                                      </div>

                    
                                    </div>
                                  </form>
                                </div>
                            </div>

                            <div className="col-xl-4 order-1 order-xl-2">
                                <div className="address-content round-wrap-content">
                                    <div className="title-box4">
                                        <h4 className="heading">Let's Get In Touch<span className="bg-theme-blue"></span></h4>
                                    </div>

                                    <div className="steps-wrap">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="steps-box mt-0">
                                                    <span><i data-feather="map-pin"></i></span>
                                                    <div className="content">
                                                        <h4 className="title-color">Address</h4>
                                                        <p className="content-color">Old No. 32A, New No.40,<br /> 5th St, Lakshmipuram,<br /> Masakali Palayam, peelamadu<br /> Tamil Nadu 641004</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="steps-box">
                                                    <span><i data-feather="mail"></i></span>
                                                    <div className="content">
                                                        <h4 className="title-color">Email Address</h4>
                                                        <p className="content-color">welbeinginfo@gmail.com</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="steps-box">
                                                    <span><i data-feather="phone"></i></span>
                                                    <div className="content">
                                                        <h4 className="title-color">Contact Number</h4>
                                                        <p className="content-color">+91 9047473959</p>
                                                        <p className="content-color">+91 9865651212</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="map-section">
                    <div className="row g-0">
                        <div className="col-12 p-0">
                            <div className="location-map">
                                <iframe
                                    title="Location Map"
                                    className="map-iframe"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.2407539208652!2d77.0170682750454!3d11.020554889143442!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba857a6381ea5fb%3A0x31660aa6f5e1598e!2sWelbeing%20Bags%20-%20Jute%20Bags%2C%20Cotton%20Bags%2C%20Thamboolam%20Bags%2C%20Logo%20Printing%20Bags%2C%20Market%20Bags!5e0!3m2!1sen!2sin!4v1697482580058!5m2!1sen!2sin"
                                    width="600"
                                    height="800"
                                    style={{ border: 0 }}
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade">
                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer/>
        </>
    );
}

export default Contact;